import { Box } from '@mui/material';

export function DataTable_LEGACYCard({ children }: React.PropsWithChildren) {
  return <Box sx={{ height: '100%', flexGrow: 1 }}>{children}</Box>;
}
